<template>
  <div>
    <form @submit.prevent="subirArchivo">
      <div class="input-group">
        <label for="idPedido">ID del Pedido:</label>
        <input v-model="idPedido" type="text" required />
      </div>
      <div class="input-group">
        <label for="archivo">Seleccionar archivo:</label>
        <input type="file" @change="onFileChange" required />
      </div>
      <button type="submit">Subir Archivo</button>
    </form>
  </div>
</template>

<script>
import api from "@/services/api";

export default {
  data() {
    return {
      idPedido: '',
      archivo: null
    };
  },
  methods: {
    onFileChange(e) {
      this.archivo = e.target.files[0];
    },
    async subirArchivo() {
      const formData = new FormData();
      formData.append('idPedido', this.idPedido);
      formData.append('archivo', this.archivo);

      try {
        const response = await api.post('/archivos/subir', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        alert('Archivo subido exitosamente'+response);
      } catch (error) {
        console.error('Error al subir el archivo:', error);
      }
    }
  }
};
</script>